import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import Events from '../utilities/EventEmitter';
const ReadOnlyNotification = () => {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    Events.on('showReadOnlyNotification', showNotification);
    return () => {
      Events.off('showReadOnlyNotification', showNotification);
    };
  }, []);

  const showNotification = () => {
    enqueueSnackbar("You have 'read-only' access and cannot create or modify content", {
      variant: 'error'
    });
  };

  return null;
};

export default ReadOnlyNotification;
